/**
 * Single source of truth for player-facing CREATURE display names.
 *
 * The wire-id (`creatureType` on the Creature schema) never changes — it's
 * threaded through the server, AI, drop tables, pet coupling, and ~30 qa
 * suites. The player-facing name is a separate display layer (the prehistoric
 * re-theme: `Wolf`→"Sabertooth", `Sheep`→"Bison", etc.). See the canonical
 * map in `docs/build/prehistoric-taxonomy.md`.
 *
 * EVERY UI surface that prints a creature name MUST go through
 * `creatureDisplayName()` so hover, click/target overlay, and the pet frame
 * never disagree. (Before this module they each read the raw type or a local
 * copy, so a tamed Sabertooth's pet slot said "Wolf" while world-hover said
 * "Sabertooth".)
 */

/** Creature wire-type → display name (KTS-verbatim where it differs). */
export const CREATURE_NAMES: Record<string, string> = {
  Stag: "Stag",
  Sheep: "Bison",
  Fox: "Fox",
  Wolf: "Sabertooth",
  Bear: "Cave Bear",
  Lyote: "Direwolf",
  Ghoul: "Ghoul",
  UndeadKobold: "Undead Kobold",
  Wight: "Wight",
  Drekavac: "Drekavac",
  KingFurbeastIV: "King Furbeast",
  TheOldMammoth: "Columbian Mammoth",
  Nightwisp: "Nightwisp",
};

/** Resolve a creature wire-type to its player-facing name (falls back to the
 *  raw type so an unmapped creature still reads, never blank). */
export function creatureDisplayName(type: string): string {
  return CREATURE_NAMES[type] ?? type;
}
